import { createApi } from "@reduxjs/toolkit/query/react"
import { Paged, PagedQuery } from "../../app/types.ts"
import { baseQueryWithReauth } from "../../app/utils.ts"

export type OperatorFactTrend = {
  call_type: string
  fact_title: string
  top_fact_rate_all: number
  bottom_fact_rate_operator: number
  avg_fact_rate: number
}

export const factTrendsApi = createApi({
  reducerPath: "factTrendsApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/analytics/" }),
  endpoints: builder => ({
    getOperatorFactTrends: builder.query<
      Paged<OperatorFactTrend>,
      PagedQuery & { operatorId: number; startDate: string; endDate: string; organizationId: number }
    >({
      query: params => {
        const searchParams = new URLSearchParams()
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            searchParams.append(key, value.toString())
          }
        })
        return `operator-fact-trends?${searchParams.toString()}`
      },
    }),
  }),
})

export const { useGetOperatorFactTrendsQuery } = factTrendsApi
